<template>
  <div
    class="subscription-row d-flex align-items-center mb-2"
    :class="{ clickable }"
  >
    <i
      class="report-type-icon text-secondary pr-3 pl-1"
      :class="sub.reportType.icon"
    />
    <div class="flex-grow-1">
      <div class="d-flex">
        <span class="font-weight-bold flex-grow-1">
          {{ sub.config.name || typeName }}
        </span>
        <div class="small">
          <template v-if="sub.config.emailDisabled">
            <span class="fa-stack">
              <i class="far fa-envelope fa-stack-1x" />
              <i class="fas fa-slash fa-stack-1x" />
            </span>
          </template>
          <template v-else>
            <i class="far fa-clock" />
            {{ sub.config.hour }}
            <span v-if="sub.config.dayOffset">
              <i
                class="far ml-1"
                :class="sub.config.skipWeekend ? 'fa-calendar-week' : 'fa-calendar'"
              />
              &nbsp;<span v-if="sub.config.dayOffset > 0">+</span>{{ sub.config.dayOffset }}
            </span>
          </template>
        </div>
      </div>
      <div class="subscription-details small text-secondary">
        <div class="d-flex align-items-center mb-1">
          <div class="detail-icon">
            <i class="far fa-users" />
          </div>
          <div>
            {{ sub.groups.join(', ') }}
          </div>
        </div>
        <div
          v-if="!sub.config.emailDisabled"
          class="d-flex align-items-center"
        >
          <div class="detail-icon">
            <i class="far fa-envelope" />
          </div>
          <div>
            {{ sub.config.emails.join(', ') }}
          </div>
        </div>
      </div>
    </div>

    <slot />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    sub: Object,
    clickable: Boolean,
  },
  computed: {
    ...mapGetters('shop', [
      'ordersReportTypes',
    ]),
    typeName() {
      return this.ordersReportTypes.find((t) => t.type === this.sub.type)?.text;
    },
  },
};
</script>

<style lang="scss" scoped>
.subscription-row {
  padding: 5px 10px;
  border: 1px solid #eee;
  border-radius: 10px;

  &.clickable {
    cursor: pointer;
    &:hover {
      background-color: #fafafa;
    }
  }

  .report-type-icon {
    font-size: 1.2rem;
  }
}

.detail-icon {
  width: 30px;
  min-width: 30px;
  text-align: center;
}

.subscription-details {
  line-height: 1.1;
}
</style>
